export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8568.c9727324.jpg";